import App from "@frog/source/models/App.js"
import Navigation from "@frog/source/models/Navigation.js"

import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"

export function EncounterVictories({encounterKeys, nextURL, spotTag, healingPercent}) {
    return encounterKeys.map((encounterKey, index) => {
        if(encounterKeys[index + 1] != undefined) {
            return {
                "type": "condition",
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.currentEncounterKey == encounterKey
                        && PlotConditions.areAllUnaffiliatedUnitsDefeated(stage, {"affiliation": stage.player.affiliation})
                },
                "events": [
                    PlotSteps.HealPlayerPartyScript({"percent": healingPercent}),
                    PlotSteps.MoveEncounterScript({"nextEncounterKey": encounterKeys[index + 1], "spotTag": spotTag})
                ]
            }
        } else {
            return {
                "type": "condition",
                "isWinCondition": true,
                "condition": (stage) => {
                    return stage.currentEncounterKey == encounterKey
                        && PlotConditions.areAllUnaffiliatedUnitsDefeated(stage, {"affiliation": stage.player.affiliation})
                },
                "events": [
                    (stage) => {
                        return {
                            "name": "SavestateCapture",
                            "savestateSlug": "winChapter_" + stage.chapterSlug,
                        }
                    },
                    PlotSteps.ChapterSuccess(),
                    {"func": () => Navigation.go(nextURL)},
                ]
            }
        }
    })
}

export function ChapterFailure() {
    return {
        "type": "condition",
        "condition": function(stage) {
            return PlotConditions.areAllAffiliatedUnitsDefeated(stage, {"affiliation": stage.player.affiliation})
        },
        "events": [
            PlotSteps.ChapterFailure(),
            {"func": () => App.game.chapter.restart()},
        ]
    }
}
